const INITIAL_STATE = {
  modalVisible: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MODAL_ADD_VISIBLE":
      return {
        ...state,
        modalVisible: !state.modalVisible,
      };
    default:
      return state;
  }
};

export default reducer;